import { route as searchSuggestionsV2Route } from "@faire/web-api--source/api/v2/search/suggestions/post";
export var getSearchSuggestionsQueryKey = function(query) {
    return [
        searchSuggestionsV2Route,
        query
    ];
};
export var EMPTY_SEARCH_SUGGESTION_QUERY_KEY = getSearchSuggestionsQueryKey("");
